<template>
	<div class="c-reading-view">
		<template v-for="item in computedNotes">
			<component
				v-if="item.type === 'header'"
				:is="'readingHeader'"
				:title="item.title"
				:composition="item.composition"
				:headerKey="item.headerKey"
				:href="item.href"
				:color="item.color"
				:avatarUrl="item.avatarUrl"
				:key="item.domain"
			>
			</component>
			<component
				v-if="item.type === 'divider'"
				:is="'readingDivider'"
				:key="'divider-' + item.index"
				:forceOpen="shouldForceOpen"
				:headerKey="item.headerKey"
				:title="item.title"
			>
			</component>
			<component
				v-if="item.type === 'note'"
				:is="'readingItem'"
				:headerKey="item.headerKey"
				:note="item.item"
				:forceOpen="shouldForceOpen"
				:showBucket="false"
				:key="item.domain"
			>
			</component>
		</template>
		<!-- <CommentEditor ref="comment"></CommentEditor> -->
	</div>
</template>

<script>
import ReadingItem from '@/components/dashboard/reading-item';
import ReadingDivider from '@/components/dashboard/reading-divider';
import ReadingHeader from '@/components/dashboard/reading-header';
import CommentEditor from '@/components/ui/comment-editor';

export default {
	components: {
		ReadingItem,
		ReadingDivider,
		ReadingHeader,
		CommentEditor,
	},
	props: ['computedNotes'],
	computed: {
		shouldForceOpen: function () {
			if (this.currentFolder) {
				return true;
			} else {
				return false;
			}
		},
		currentFolder: function () {
			return this.$store.getters['dashboard/folder'];
		},
	},
	methods: {},
};
</script>

<style lang="scss">
.c-reading-view {
	max-width: 760px;
	padding: 0 var(--margin-sm);
	margin: 0 auto;
}
</style>